import { Injectable } from '@angular/core';
import { RequestResponse } from '../intefaces/requestResponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {

  constructor(protected http: HttpClient) {
    super();
  }

  public getMyDetails() {
    return this.http.get<RequestResponse>(this.getUrl('myDetails'));
  }

  public updateUserDetails(data: any) {
    return this.http.post<RequestResponse>(this.getUrl('updateUserDetails'), data);
  }

  public changeEmail(data: any) {
    return this.http.post<RequestResponse>(this.getUrl('changeEmailAddress'), data);
  }

  public verifyChangeEmailCode(data: any) {
    return this.http.post<RequestResponse>(this.getUrl('verifyChangeEmailCode'), data);
  }

  public changePassword(data: any) {
    return this.http.post<RequestResponse>(this.getUrl('changePasswordAccount'), data);
  }

  public isAdmin() {
    return this.http.get<RequestResponse>(this.getUrl('isAdmin'));
  }

  public isArranger() {
    return this.http.get<RequestResponse>(this.getUrl('isArranger'));
  }

  public getArrangerDetails() {
    return this.http.get<RequestResponse>(this.getUrl('getArrangerDetails'));
  }

  public getAllArrangers() {
    return this.http.get<RequestResponse>(this.getUrl('getAllArrangers'));
  }

  public updateShortDesc(data: any) {
    return this.http.post<RequestResponse>(this.getUrl('updateShortDesc'), data);
  }

  public updateFullDesc(data: any) {
    return this.http.post<RequestResponse>(this.getUrl('updateFullDesc'), data);
  }

  public updateArrangerDetails(data: any) {
    return this.http.post<RequestResponse>(this.getUrl('updateArrangerDetails'), data);
  }

  public uploadPhoto(photo: any) {
    return this.http.post<RequestResponse>(this.getUrl('uploadPhoto'), photo);
  }

  public deleteAccount() {
    return this.http.delete<RequestResponse>(this.getUrl('deleteAccount'));
  }

  public updatePrepaidAmount(object) {
    return this.http.post<RequestResponse>(this.setUrl('admin/updatePrepaid'), object);
  }
}
